import { clsx } from 'clsx'
import React from 'react'

interface ButtonPrimaryProps {
  children: React.ReactElement
  onClick: () => void
  className?: string
  disable?: boolean
  error?: boolean
}

export function ButtonPrimaryV2({ children, onClick, className, disable, error }: ButtonPrimaryProps) {
  return (
    <button
      disabled={disable || error}
      onClick={onClick}
      className={clsx(
        `h-[56px] px-[24px] flex items-center justify-center text-[16px] leading-[24px] tracking-[-0.32px] font-medium text-black bg-white w-full rounded-full`,
        className,
        { 'opacity-30': disable },
        {
          'hover:opacity-90': !disable,
        }
      )}
    >
      {children}
    </button>
  )
}
